import React from 'react';
import {
  Box,
  BoxProps,
  Button,
  ButtonProps,
  withStyles,
} from '@material-ui/core';
import cn from 'classnames';
import { centerBoxProps, spaceBetweenBoxProps } from 'globals/utils';
import FsBodySmall from 'ui-elements/typography/FsBodySmall';
import FsButton from 'ui-elements/buttons/FsButton';
import FsLink from 'ui-elements/links/FsLink';

interface PageWrapperBoxProps extends BoxProps {
  isWhiteBackground?: boolean;
}

export const PageWrapperBox = withStyles(({ palette }) => ({
  root: {
    minHeight: `100vh`,
    '&.whiteBackground': {
      background: palette.common.white,
    },
  },
}))(({ isWhiteBackground = true, ...otherProps }: PageWrapperBoxProps) => (
  <Box {...otherProps} className={cn({ whiteBackground: isWhiteBackground })} />
));

interface HeaderBoxProps extends BoxProps {
  isStatic?: boolean;
}

export const HeaderBox = withStyles(({ spacing, breakpoints }) => ({
  root: {
    ...spaceBetweenBoxProps,
    padding: spacing(2, 1.5),
    [breakpoints.up('sm')]: {
      padding: spacing(3.5),
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
    },
    '&.static': {
      position: 'static',
      padding: spacing(2, 1.5),
    },
  },
}))(({ isStatic = false, ...otherProps }: HeaderBoxProps) => (
  <Box {...otherProps} className={cn({ static: isStatic })} />
));

export const LogoWrapperBox = withStyles(() => ({
  root: {
    ...centerBoxProps,
  },
}))(Box);

export const StyledIconButton = withStyles(({ spacing }) => ({
  root: {
    padding: spacing(0.5),
    borderRadius: spacing(1),
    minWidth: 'auto',
    '&:hover': {
      background: 'transparent',
    },
  },
}))(Button);

export const BackToPanelLink = withStyles(
  ({ breakpoints, spacing, palette }) => ({
    root: {
      alignItems: 'center',
      color: palette.grey[300],
      marginLeft: spacing(2.2),
      display: 'none',
      [breakpoints.up('sm')]: {
        display: 'flex',
      },
    },
  })
)(FsLink);

export const BackToPanelLabel = withStyles(({ spacing }) => ({
  root: {
    textTransform: 'uppercase',
    marginLeft: spacing(1),
  },
}))(FsBodySmall);

export const LogInWrapperBox = withStyles(() => ({
  root: {
    ...centerBoxProps,
  },
}))(Box);

export const LogInLabel = withStyles(({ palette, breakpoints }) => ({
  root: {
    display: 'none',
    color: palette.grey[400],
    [breakpoints.up('sm')]: {
      display: 'block',
    },
  },
}))(FsBodySmall);

export const LogInButton = withStyles(({ palette, spacing }) => ({
  root: {
    padding: spacing(0.6, 3.7),
    color: palette.grey[400],
    fontSize: 14,
    fontWeight: 400,
    marginLeft: spacing(2),
  },
}))((props: ButtonProps) => (
  <FsButton {...props} variant="outlined" size="small" />
));

interface ContextBoxProps extends BoxProps {
  isFullHeight?: boolean;
}

export const ContextBox = withStyles(({ spacing, breakpoints }) => ({
  root: {
    ...centerBoxProps,
    padding: spacing(5, 2, 2, 2),
    [breakpoints.up('sm')]: {
      minHeight: '100vh',
      padding: spacing(3),
    },
    '&.noFullHeight': {
      [breakpoints.up('sm')]: {
        minHeight: 'auto',
        padding: spacing(3),
      },
    },
  },
}))(({ isFullHeight = true, ...otherProps }: ContextBoxProps) => (
  <Box {...otherProps} className={cn({ noFullHeight: !isFullHeight })} />
));

export const RightTopBox = withStyles(() => ({
  root: {
    ...centerBoxProps,
  },
}))(Box);
